module.exports = __webpack_public_path__ + "static/img/Five of Wands.df6e40b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Five of Wands.jpg
// module id = 1268
// module chunks = 0